import { type NavigationGuard } from 'vue-router';
import { api } from '@/axios/instance/api';
import type { Permission } from '@/ccpv2/types/ccp-details';
import type { SettingsRole } from '@/ccpv2/types/ccp-settings';
import { useAuthStore } from '@/stores/auth';
import { useCompanyStore } from '@/stores/company';

export const companyUsesCcpV2: NavigationGuard = (to, from, next) => {
  const companyStore = useCompanyStore();
  const hasCcp = companyStore.hasCompCyclePlanning;

  if (hasCcp) {
    return next();
  } else {
    return next({ name: 'home' });
  }
};

export const redirectToHomeIfNotAdmin: NavigationGuard = async (to, from, next) => {
  const authStore = useAuthStore();

  if (authStore.isUserAdmin) {
    return next();
  } else {
    return next({ name: 'ccpv2-list' });
  }
};

export const redirectToHomeIfNoCCPAccess: NavigationGuard = async (to, from, next) => {
  const authStore = useAuthStore();

  if (authStore.appAccess.nav.comp_cycle) {
    return next();
  } else {
    return next({ name: 'home' });
  }
};

export const redirectToNotFoundIfNoWaveId: NavigationGuard = async (to, from, next) => {
  if (!to.params.waveId) {
    return next({ name: 'ccpv2-only-404' });
  }

  return next();
};

export const redirectToHomeIfNotPermission =
  (permission: Permission): NavigationGuard =>
  async (to, from, next) => {
    const { data, error } = await api.get<SettingsRole>(`v2/ccp/roles/${to.params.roleId}/permissions`);

    if (error || !data[permission]) {
      return next({ name: 'ccpv2-list' });
    }

    return next();
  };
